import React from 'react';
import { connect } from 'react-redux';

import {
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  ListGroup,
  ListGroupItem
} from 'reactstrap';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Switch, Redirect, Route, Link, NavLink } from 'react-router-dom';
import Dynamic from '../Dynamic/Dynamic';
import ProductCta from '../../components/ProductCta/ProductCta';
import ProductCtaBar from '../../components/ProductCta/ProductCtaBar';
import { getActualHostname, getBrandingContext } from '../../utils/hostname';

import pageComponents from './assistance/';

const { isNais } = getBrandingContext();

let linkAssistance =
  'https://www.axa-assistance.pl/ubezpieczenie-pojazdu/?ExternalPartner=13000170';

if (isNais)
  linkAssistance =
    'https://www.axa-assistance.pl/ubezpieczenie-pojazdu/?ExternalPartner=13100174';

const pracownicyData = [
  { title: 'Informacje Ogólne', component: 'Ogolne', link: 'opis/' }
];

class PublicTwoColumnTemplate extends React.Component {
  render() {
    let currentBreadcrumb;

    const menu = pracownicyData.map((item) => {
      if (item.externalLink) {
        return (
          <ListGroupItem
            tag="a"
            key={item.title}
            href={item.externalLink}
            target="_blank"
            rel="noopener noreferrer"
            action>
            {item.title}
          </ListGroupItem>
        );
      }

      if (
        !currentBreadcrumb &&
        (`${this.props.match.path}${item.link}` ===
          this.props.location.pathname ||
          `${this.props.match.path}${item.link}` ===
            `${this.props.location.pathname}/`)
      ) {
        currentBreadcrumb = (
          <BreadcrumbItem active>{item.title}</BreadcrumbItem>
        );
      }

      const link = `${this.props.match.path}${item.link}`;
      return (
        <ListGroupItem tag={NavLink} key={item.title} to={link} action>
          {item.title}
        </ListGroupItem>
      );
    });

    const routes = pracownicyData.map((item) => {
      if (item.component) {
        return (
          <Route
            key={item.link}
            path={`${this.props.match.path}${item.link}`}
            component={pageComponents[item.component]}
          />
        );
      }
      return null;
    });
    const isTvpTuw =
      getActualHostname() === 'tvp-tuwpzuw.uspartner.pl' &&
      new Date('2022-10-24').getTime() > new Date().getTime();
    // A menu with the current page as its only entry leads nowhere - skip it
    const hasMenu = pracownicyData.length > 1;
    return (
      <div>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/">{this.props.rootSection}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to={this.props.match.path}>{this.props.section}</Link>
          </BreadcrumbItem>
          {currentBreadcrumb}
        </Breadcrumb>

        <Row>
          <Col xs="12" sm="3">
            <div className="productSidebarSticky">
              {hasMenu && <ListGroup>{menu}</ListGroup>}
              {!isTvpTuw && (
                <ProductCta
                  href={linkAssistance}
                  icon={faShoppingCart}
                  className={hasMenu ? 'mt-4' : undefined}
                  block>
                  Kup ubezpieczenie
                </ProductCta>
              )}
            </div>
          </Col>
          <Col xs="12" sm="9">
            <Switch>
              {routes}
              {this.props.isAuthenticated && (
                <Route
                  path={`/assistance/kup/`}
                  render={(props) => (
                    <Dynamic
                      {...props}
                      guid="e5044f7c-37ab-4ca0-afa6-1d512a29fbee"
                      // key={props.match.params.guid}
                    />
                  )}
                />
              )}
              <Redirect exact from="/assistance" to="/assistance/opis/" />
              <Redirect
                from="/assistance/kup/"
                to={{
                  pathname: '/login',
                  state: { referrer: this.props.location.pathname }
                }}
              />
              <Redirect
                to={{
                  pathname: '/login',
                  state: { referrer: this.props.location.pathname }
                }}
              />
            </Switch>
          </Col>
        </Row>
        {!isTvpTuw && (
          <ProductCtaBar title="Moto Assistance">
            <ProductCta href={linkAssistance} icon={faShoppingCart}>
              Kup ubezpieczenie
            </ProductCta>
          </ProductCtaBar>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null
    // username: state.auth.user.name,
    // menu: state.menu.data ? state.menu.data.menu : []
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // logout: () => dispatch(logout())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicTwoColumnTemplate);
